export default {
  BT_HDP: "핸디캡 | HDP",
  BT_OU: "오버/언더 | O/U",
  BT_ML: "머니라인",
  BT_1X2: "1X2",
  BT_1X2HDP: "3방향 핸디캡",
  BT_CS: "정확한 스코어",
  BT_OE: "홀/짝 | O/E",
  BT_DC: "더블 찬스",
  BT_HTFT: "전반/경기 전체",
  BT_FGLG: "첫 득점/마지막 득점",
  BT_TG: "총 득점",
  BT_OR: "우승팀",
  BT_ORZ: "우승팀",

  BT_ANB: "원정팀 무효",
  BT_BS: "양팀/한 팀/득점 없음",
  BT_CL: "무실점",
  BT_DNB: "무승부 제외",
  BT_DNBH: "전반 무승부 제외",
  BT_HNB: "홈팀 무효",
  BT_TWTN: "무실점 승리",

  BT_HDPF: "경기 전체 핸디캡 | 경기 전체 HDP",
  BT_OUF: "경기 전체 오버/언더 | 경기 전체 O/U",
  BT_MLF: "경기 전체 머니라인 | 경기 전체 ML",
  BT_1X2F: "경기 전체 1X2",
  BT_1X2HDPF: "경기 전체 3방향 핸디캡",
  BT_CSF: "경기 전체 정확한 스코어",
  BT_OEF: "경기 전체 홀/짝 | 경기 전체 O/E",
  BT_DCF: "경기 전체 더블 찬스",
  BT_FGLGF: "경기 전체 첫 득점/마지막 득점",
  BT_TGF: "경기 전체 총 득점",

  BT_HDPH: "전반 핸디캡 | 전반 HDP",
  BT_OUH: "전반 오버/언더 | 전반 O/U",
  BT_MLH: "전반 머니라인 | 전반 ML",
  BT_1X2H: "전반 1X2",
  BT_1X2HDPH: "전반 3방향 핸디캡",
  BT_CSH: "전반 정확한 스코어",
  BT_OEH: "전반 홀/짝 | 전반 O/E",
  BT_DCH: "전반 더블 찬스",
  BT_FGLGH: "전반 첫 득점/마지막 득점",
  BT_TGH: "전반 총 득점",
  BT_O: "오버",
  BT_U: "언더",
  BT_ODD: "홀",
  BT_EVEN: "짝",

  BT_HDPOU: "핸디캡 & 오버/언더",
  BT_PARLAY: "조합 베팅",
  BT_FT: "경기 전체. ",
  BT_1H: "전반. ",
  BT_2H: "후반. ",

  BT_FG: "첫 득점",
  BT_LG: "마지막 득점",
  BT_HFG: "홈팀 첫 득점",
  BT_AFG: "원정팀 첫 득점",
  BT_HLG: "홈팀 마지막 득점",
  BT_ALG: "원정팀 마지막 득점",
  BT_NG: "무득점",
  BT_HY: "홈 예",
  BT_HN: "홈 아니요",
  BT_AY: "원정 예",
  BT_AN: "원정 아니요",
  BT_H: "홈",
  BT_A: "원정",
  BT_D: "무승부",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "예",
  BT_N: "아니요",

  BT_LIVE: "라이브",
  BT_HT: "전반 종료",
  BT_DELAYED: "지연",
  BT_PEN: "승부차기",

  BT_FT1: "경기 전체 1",
  BT_FT2: "경기 전체 2",
  BT_FTX: "경기 전체 X",
  BT_HT1: "전반 1",
  BT_HT2: "전반 2",
  BT_HTX: "전반 X",

  BT_BOTH: "양팀",
  BT_ONE: "한 팀",

  BS_HDP: "경기 전체 핸디캡",
  BS_HDPH: "전반 핸디캡",
  BS_OU: "경기 전체 오버/언더",
  BS_OUH: "전반 오버/언더",
  BS_OE: "경기 전체 홀/짝",
  BS_OEH: "전반 홀/짝",
  BS_1X2: "경기 전체 1X2",
  BS_1X2H: "전반 1X2",
  BS_ML: "경기 전체 머니라인",
  BS_MLH: "전반 머니라인",
  BS_1X2HDP: "경기 전체 3방향 핸디캡",
  BS_1X2HDPH: "전반 3방향 핸디캡",
  BS_CS: "경기 전체 정확한 스코어",
  BS_CSH: "전반 정확한 스코어",
  BS_DC: "경기 전체 더블 찬스",
  BS_DCH: "전반 더블 찬스",
  BS_FGLG: "경기 전체 첫/마지막 득점",
  BS_FGLGH: "전반 첫/마지막 득점",
  BS_TG: "경기 전체 총 득점",
  BS_TGH: "전반 총 득점",
  BS_ANB: "원정팀 무효",
  BS_HTFT: "전반/경기 전체",
  BS_BS: "양팀/한 팀/득점 없음",
  BS_CL: "무실점",
  BS_DNB: "무승부 제외",
  BS_DNBH: "전반 무승부 제외",
  BS_HNB: "홈팀 무효",
  BS_TWTN: "무실점 승리",
  BS_OR: "우승팀",
  BS_ORZ: "우승팀",

  LOT_BS: "대/소",
  LOT_BIG: "대",
  LOT_SMALL: "소",
  LOT_OE: "홀/짝",
  LOT_ODD: "홀",
  LOT_EVEN: "짝",
  LOT_OU: "오버/언더",
  LOT_OVER: "오버",
  LOT_UNDER: "언더",
  LOT_FT: "경기 전체",
  LOT_HT: "전반",

  BT_ALLBT: "전체 베팅 유형",

  D_1: "단일 번호",
  D_2: "번호 및 역순",
  D_3: "복식",
  D_4: "아이박스",
  D_5: "끝 3자리 복식",
  D_6: "끝 2자리 복식",

  D_BIG: "대",
  D_SMALL: "소",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  LOT_1: "H",
  LOT_0: "A",

  BT_KO: "KO 방식",

  ODD_Home: "H",
  ODD_Away: "A",
  ODD_Draw: "D",
  ODD_Over: "O",
  ODD_Under: "U",
  ODD_Odd: "O",
  ODD_Even: "E",

  GH_1X2: "승리",
  GH_1X20: "승리",
  GH_1X2HDP: "플레이스/쇼",
  GH_1X2HDP2: "플레이스",
  GH_1X2HDP4: "쇼",
  GH_OVER: "오버 (4,5,6)",
  GH_UNDER: "언더 (1,2,3)",
  GH_ODD: "홀 (1,3,5)",
  GH_EVEN: "짝 (2,4,6)",
  GH_OU1: "오버 (4,5,6)",
  GH_OU2: "언더 (1,2,3)",
  GH_OE1: "홀 (1,3,5)",
  GH_OE2: "짝 (2,4,6)",

  GX_1X2: "승리",
  GX_1X20: "승리",
  GX_1X2HDP: "플레이스/쇼",
  GX_1X2HDP2: "플레이스",
  GX_1X2HDP4: "쇼",
  GX_OVER: "오버 (7-12)",
  GX_UNDER: "언더 (1-6)",
  GX_ODD: "홀 (1,3,5,7,9,11)",
  GX_EVEN: "짝 (2,4,6,8,10,12)",
  GX_OU1: "오버 (7-12)",
  GX_OU2: "언더 (1-6)",
  GX_OE1: "홀 (1,3,5,7,9,11)",
  GX_OE2: "짝 (2,4,6,8,10,12)",

  GC_OU: "오버/언더",
  GC_OE: "홀/짝",
  GC_OVER: "오버 (3,4,5)",
  GC_UNDER: "언더 (0,1,2)",
  GC_ODD: "홀 (1,3,5)",
  GC_EVEN: "짝 (0,2,4)",
  GC_5_0: "5-0",
  GC_4_1: "4-1",
  GC_3_2: "3-2",
  GC_0_5: "0-5",
  GC_1_4: "1-4",
  GC_2_3: "2-3",
  GC_ML0: "첫 번째 공",
  GC_1X20: "승리",
  GC_ML: "첫 번째 공",
  GC_1X2: "승리",
  GC_OU1: "오버 (3,4,5)",
  GC_OU2: "언더 (0,1,2)",
  GC_OE1: "홀 (1,3,5)",
  GC_OE2: "짝 (0,2,4)",

  GR_RED: "빨강 (1)",
  GR_YELLOW: "노랑 (2)",
  GR_BLUE: "파랑 (3)",
  GR_GREEN: "초록 (4)",
  GR_OVER: "오버 (3,4)",
  GR_UNDER: "언더 (1,2)",
  GR_ODD: "홀 (1,3)",
  GR_EVEN: "짝 (2,4)",
  GR_SINGLE: "싱글",
  GR_PAIR: "페어",
  GR_TRIPS: "트리플",
  GR_ADVANCED: "진출",
  GR_ELIMINATED: "탈락",
  GR_HIT1: "적중 1",
  GR_HIT2: "적중 2",
  GR_PERFECT: "퍼펙트",
  GR_MLHOME: "진출",
  GR_MLAWAY: "탈락",
  GR_1X2FT1: "싱글",
  GR_1X2FTX: "페어",
  GR_1X2FT2: "트리플",
  GR_ML1: "진출",
  GR_ML2: "탈락",
  GR_1X21: "싱글",
  GR_1X22: "트리플",
  GR_1X23: "페어",
  GR_OU1: "오버 (3,4)",
  GR_OU2: "언더 (1,2)",
  GR_OE1: "홀 (1,3)",
  GR_OE2: "짝 (2,4)",

  ROOM_A: "오픈",
  ROOM_0: "진행 중",
  ROOM_1: "마감",
  ROOM_2: "취소",
  ROOM_3: "종료",
  ROOM_4: "베팅 중지",
  ROOM_10: "전체",

  ROOM_T0: "전체",
  ROOM_T1: "공개 룸",
  ROOM_T2: "비공개 룸",
  ROOM_T3: "플레이하고 적립",

  joinRoom1: "공개 룸 참가",
  joinRoom2: "비공개 룸 참가",
  joinRoom3: "플레이 룸 참가",
  createRoom1: "공개 룸 생성",
  createRoom2: "비공개 룸 생성",
  createRoom3: "플레이 룸 생성",
  Champion: "우승",
  FirstRunnerUp: "준우승",
  SecondRunnerUp: "3위",

  BT_OEHM: "홈팀 홀/짝",
  BT_OEHMH: "전반 홈팀 홀/짝",
  BT_OEAW: "원정팀 홀/짝",
  BT_OEAWH: "전반 원정팀 홀/짝",

  BS_OEHM: "경기 전체 홈팀 홀/짝",
  BS_OEHMH: "전반 홈팀 홀/짝",
  BS_OEAW: "경기 전체 원정팀 홀/짝",
  BS_OEAWH: "전반 원정팀 홀/짝",

  MB_OVER: "오버 (4,5,6)",
  MB_UNDER: "언더 (1,2,3)",
  MB_ODD: "홀 (1,3,5)",
  MB_EVEN: "짝 (2,4,6)",

  BS_1X2OU: "1X2 + 오버/언더",
  BT_1X2OU: "1X2 + 오버/언더",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "더블 찬스 + 오버/언더",
  BT_DCOU: "더블 찬스 + 오버/언더",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "오버/언더 + 홀/짝",
  BT_OUOE: "오버/언더 + 홀/짝",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "전반/경기 전체 + 홀/짝",
  BT_HTFTOE: "전반/경기 전체 + 홀/짝",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "승리 마진",
  BT_WM: "승리 마진",
  BK_H1: "홈 1",
  BK_H2: "홈 2",
  BK_H3Up: "홈 3+",
  BK_A1: "원정 1",
  BK_A2: "원정 2",
  BK_A3Up: "원정 3+",
  BK_D: "득점 무승부 (0-0 제외)",
  BK_NG: "무득점",

  BS_ETG: "정확한 총 득점",
  BT_ETG: "정확한 총 득점",
  BS_EHTG: "홈팀 정확한 총 득점",
  BT_EHTG: "홈팀 정확한 총 득점",
  BS_EATG: "원정팀 정확한 총 득점",
  BT_EATG: "원정팀 정확한 총 득점",
  BS_ETGH: "전반 정확한 총 득점",
  BT_ETGH: "전반 정확한 총 득점",
  BS_EHTGH: "전반 홈팀 정확한 총 득점",
  BT_EHTGH: "전반 홈팀 정확한 총 득점",
  BS_EATGH: "전반 원정팀 정확한 총 득점",
  BT_EATGH: "전반 원정팀 정확한 총 득점",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "전반/경기 전체 정확한 스코어",
  BS_CSHTFT: "전반/경기 전체 정확한 스코어",
  BT_ETGHTFT: "전반/경기 전체 정확한 총 득점",
  BS_ETGHTFT: "전반/경기 전체 정확한 총 득점",

  CF_CS_2_1: "2-1",
  CF_CS_2_0: "2-0",
  CF_CS_0_2: "0-2",
  CF_CS_1_2: "1-2",
  CF_R_1_W: "1라운드 승자",
  CF_R_2_W: "2라운드 승자",
  CF_R_3_W: "3라운드 승자",
  CF_MLHOME: "홈 승",
  CF_MLAWAY: "원정 승",
  CF_EVEN: "2라운드 경기",
  CF_ODD: "3라운드 경기",
  CF_ML1: "홈 승",
  CF_ML2: "원정 승",
  CF_ML: "머니라인",
  CF_CS: "정확한 스코어",
  CF_OE: "홀/짝",
  CF_0: "R",
  CF_1: "H",
  CF_2: "A",
  CF_OE1: "홀",
  CF_OE2: "짝",

  MA_CS_3_0: "3-0",
  MA_CS_2_1: "2-1",
  MA_CS_0_3: "0-3",
  MA_CS_1_2: "1-2",
  MA_ML_TW: "팀 승리",
  MA_O: "오버",
  MA_U: "언더",
  MA_OE1: "홀",
  MA_OE2: "짝",
  MA_ML: "머니라인",
  MA_CS: "정확한 스코어",
  MA_OU: "오버/언더",
  MA_OE: "홀/짝",
  MA_R_1_W: "1라운드 승자",
  MA_R_2_W: "2라운드 승자",
  MA_R_3_W: "3라운드 승자",
  MA_T_3_R: "총 3라운드",
  MA_ANY_W_R: "한 라운드 이상 승리",
  MA_NO_W_R: "승리 라운드 없음",
  MA_W_1: "1승",
  MA_W_2: "2승",
  MA_PF: "퍼펙트",
  MA_OU1: "오버",
  MA_OU2: "언더",
  MA_ML1: "홈 승",
  MA_ML2: "원정 승",
  MA_ML_C_1: "한 라운드 이상 승리",
  MA_ML_C_2: "승리 라운드 없음",

  EF8_R1_1STBOOM: "1라운드 첫 번째 붐",
  EF8_R2_1STBOOM: "2라운드 첫 번째 붐",
  EF8_R3_1STBOOM: "3라운드 첫 번째 붐",
  EF8_0: "-",
  EF8_1: "H",
  EF8_2: "A",
};